import React, { useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { useToast } from '@/contexts/ToastContext'

const ErrorHandler: React.FC = () => {
  const toast = useToast()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const handleAuthRedirect = (event: Event) => {
      const { url } = (event as CustomEvent<{ url: string }>).detail
      navigate(url, { replace: true })
    }

    window.addEventListener('auth:redirect', handleAuthRedirect)
    return () => window.removeEventListener('auth:redirect', handleAuthRedirect)
  }, [navigate])

  useEffect(() => {
    const handleSessionExpired = () => toast.error('Sessão expirada. Faça login novamente.')
    window.addEventListener('auth:session-expired', handleSessionExpired)
    return () => window.removeEventListener('auth:session-expired', handleSessionExpired)
  }, [toast])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const error = params.get('error')

    if (error) {
      let message: string | null = null

      switch (error) {
        case 'unauthorized':
          window.dispatchEvent(new CustomEvent('auth:session-expired'))
          break
        case 'forbidden':
          message = 'Acesso proibido. Você não tem permissão para esta ação.'
          break
        default:
          message = decodeURIComponent(error)
          break
      }

      if (message) toast.error(message)
      params.delete('error')

      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
        },
        { replace: true }
      )
    }
  }, [location, navigate, toast])

  return null
}

export default ErrorHandler
